export const CANVAS_BRUSH = 'CANVAS_BRUSH';
export const CANVAS_SHAPE_SELECTION = 'SHAPE_SELECTION';
export const CANVAS_LINE = 'CANVAS_LINE';
export const CANVAS_ARROW = 'CANVAS_ARROW';
